import { buildImageSource, buildImageSourceSet } from '../../../utils/buildImageSource';
import { getIsMobile } from '../../../utils/getIsMobile';
import { IconImage } from '../../icon/IconImage';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Image } from '../../media/Image';
import { ContentUI } from '../types';
import { DEFAULT_POST_COLLECTION_RATIO } from './constants';
import { PostMediaCover } from './styles';

interface CollectionCollageProps {
    content: ContentUI[];
    index: number;
    // Велечина, которую мы должны отнять от максимальной высоты поста,
    // например высота футера в мобилке
    maxHeightOffset?: number;
    // Соотношение сторон
    ratio?: number;
}

const generateGrid = (content: ContentUI[]) => {
    if (content.length === 1) {
        const preview = content[0];

        return (
            <Box>
                {preview?.type === 'image' && (
                    <Image
                        src={buildImageSource(preview.media)}
                        srcSet={buildImageSourceSet(preview.media)}
                    />
                )}
                {preview?.type === 'video' && <Image src={preview.media[0]?.firstFrameUrl} />}
                {!preview && <IconImage fontSize="30px" fill="var(--color-primary)" />}
            </Box>
        );
    } else if (content.length === 2) {
        const firstImage = content[0];
        const secondImage = content[1];

        return (
            <Flex
                backgroundColor="var(--background-secondary)"
                direction="row"
                flexWrap="wrap"
                spacing={1 / 8}
            >
                <Flex
                    width="50%"
                    height="100%"
                    flexBasis="calc(50% - 0.5px)"
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="var(--background-primary)"
                >
                    {firstImage?.type === 'image' && (
                        <Image
                            width="100%"
                            height="100%"
                            src={buildImageSource(firstImage.media)}
                            srcSet={buildImageSourceSet(firstImage.media)}
                        />
                    )}
                    {firstImage?.type === 'video' && (
                        <Image
                            width="100%"
                            height="100%"
                            src={firstImage.media[0]?.firstFrameUrl}
                        />
                    )}
                    {!firstImage && <IconImage fontSize="30px" fill="var(--color-primary)" />}
                </Flex>
                <Flex
                    width="50%"
                    height="100%"
                    flexBasis="calc(50% - 0.5px)"
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="var(--background-primary)"
                >
                    {secondImage?.type === 'image' && (
                        <Image
                            width="100%"
                            height="100%"
                            src={buildImageSource(secondImage.media)}
                            srcSet={buildImageSourceSet(secondImage.media)}
                        />
                    )}
                    {secondImage?.type === 'video' && (
                        <Image
                            width="100%"
                            height="100%"
                            src={secondImage.media[0]?.firstFrameUrl}
                        />
                    )}
                    {!secondImage && <IconImage fontSize="30px" fill="var(--color-primary)" />}
                </Flex>
            </Flex>
        );
    } else if (content.length === 3) {
        const firstImage = content[0];
        const secondImage = content[1];
        const thirdImage = content[2];

        return (
            <Flex
                backgroundColor="var(--background-secondary)"
                direction="row"
                flexWrap="wrap"
                spacing={1 / 8}
            >
                <Flex
                    width="50%"
                    height="100%"
                    flexBasis="calc(50% - 0.5px)"
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="var(--background-primary)"
                >
                    {firstImage?.type === 'image' && (
                        <Image
                            width="100%"
                            height="100%"
                            src={buildImageSource(firstImage.media)}
                            srcSet={buildImageSourceSet(firstImage.media)}
                        />
                    )}
                    {firstImage?.type === 'video' && (
                        <Image
                            width="100%"
                            height="100%"
                            src={firstImage.media[0]?.firstFrameUrl}
                        />
                    )}
                    {!firstImage && <IconImage fontSize="30px" fill="var(--color-primary)" />}
                </Flex>
                <Flex
                    width="50%"
                    height="100%"
                    direction="column"
                    flexWrap="wrap"
                    spacing={1 / 8}
                    flexBasis="calc(50% - 0.5px)"
                >
                    <Flex
                        width="100%"
                        height="calc(50% - 0.5px)"
                        flexBasis="calc(50% - 0.5px)"
                        alignItems="center"
                        justifyContent="center"
                        backgroundColor="var(--background-primary)"
                    >
                        {secondImage?.type === 'image' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={buildImageSource(secondImage.media)}
                                srcSet={buildImageSourceSet(secondImage.media)}
                            />
                        )}
                        {secondImage?.type === 'video' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={secondImage.media[0]?.firstFrameUrl}
                            />
                        )}
                        {!secondImage && <IconImage fontSize="30px" fill="var(--color-primary)" />}
                    </Flex>
                    <Flex
                        width="100%"
                        height="calc(50% - 0.5px)"
                        flexBasis="calc(50% - 0.5px)"
                        alignItems="center"
                        justifyContent="center"
                        backgroundColor="var(--background-primary)"
                    >
                        {thirdImage?.type === 'image' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={buildImageSource(thirdImage.media)}
                                srcSet={buildImageSourceSet(thirdImage.media)}
                            />
                        )}
                        {thirdImage?.type === 'video' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={thirdImage.media[0]?.firstFrameUrl}
                            />
                        )}
                        {!thirdImage && <IconImage fontSize="30px" fill="var(--color-primary)" />}
                    </Flex>
                </Flex>
            </Flex>
        );
    } else if (content.length > 3) {
        const firstImage = content[0];
        const secondImage = content[1];
        const thirdImage = content[2];
        const fourthImage = content[3];

        return (
            <Flex
                backgroundColor="var(--background-secondary)"
                direction="row"
                flexWrap="wrap"
                spacing={1 / 8}
            >
                <Flex
                    width="50%"
                    height="100%"
                    direction="column"
                    flexWrap="wrap"
                    spacing={1 / 8}
                    flexBasis="calc(50% - 0.5px)"
                >
                    <Flex
                        width="100%"
                        height="calc(50% - 0.5px)"
                        flexBasis="calc(50% - 0.5px)"
                        alignItems="center"
                        justifyContent="center"
                        backgroundColor="var(--background-primary)"
                    >
                        {firstImage?.type === 'image' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={buildImageSource(firstImage.media)}
                                srcSet={buildImageSourceSet(firstImage.media)}
                            />
                        )}
                        {firstImage?.type === 'video' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={firstImage.media[0]?.firstFrameUrl}
                            />
                        )}
                        {!firstImage && <IconImage fontSize="30px" fill="var(--color-primary)" />}
                    </Flex>
                    <Flex
                        width="100%"
                        height="calc(50% - 0.5px)"
                        flexBasis="calc(50% - 0.5px)"
                        alignItems="center"
                        justifyContent="center"
                        backgroundColor="var(--background-primary)"
                    >
                        {thirdImage?.type === 'image' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={buildImageSource(thirdImage.media)}
                                srcSet={buildImageSourceSet(thirdImage.media)}
                            />
                        )}
                        {thirdImage?.type === 'video' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={thirdImage.media[0]?.firstFrameUrl}
                            />
                        )}
                        {!thirdImage && <IconImage fontSize="30px" fill="var(--color-primary)" />}
                    </Flex>
                </Flex>
                <Flex
                    width="50%"
                    height="100%"
                    direction="column"
                    flexWrap="wrap"
                    spacing={1 / 8}
                    flexBasis="calc(50% - 0.5px)"
                >
                    <Flex
                        width="100%"
                        height="calc(50% - 0.5px)"
                        flexBasis="calc(50% - 0.5px)"
                        alignItems="center"
                        justifyContent="center"
                        backgroundColor="var(--background-primary)"
                    >
                        {secondImage?.type === 'image' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={buildImageSource(secondImage.media)}
                                srcSet={buildImageSourceSet(secondImage.media)}
                            />
                        )}
                        {secondImage?.type === 'video' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={secondImage.media[0]?.firstFrameUrl}
                            />
                        )}
                        {!secondImage && <IconImage fontSize="30px" fill="var(--color-primary)" />}
                    </Flex>
                    <Flex
                        width="100%"
                        height="calc(50% - 0.5px)"
                        flexBasis="calc(50% - 0.5px)"
                        alignItems="center"
                        justifyContent="center"
                        backgroundColor="var(--background-primary)"
                    >
                        {fourthImage?.type === 'image' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={buildImageSource(fourthImage.media)}
                                srcSet={buildImageSourceSet(fourthImage.media)}
                            />
                        )}
                        {fourthImage?.type === 'video' && (
                            <Image
                                width="100%"
                                height="100%"
                                src={fourthImage.media[0]?.firstFrameUrl}
                            />
                        )}
                        {!fourthImage && <IconImage fontSize="30px" fill="var(--color-primary)" />}
                    </Flex>
                </Flex>
            </Flex>
        );
    } else {
        return null;
    }
};

export const CollectionCollage = (props: CollectionCollageProps) => {
    const { index, maxHeightOffset, content, ratio } = props;
    const { isMobile } = getIsMobile();

    return (
        <PostMediaCover
            key={index}
            ratio={ratio || DEFAULT_POST_COLLECTION_RATIO}
            minWidth="100%"
            isMobile={isMobile}
            maxHeightOffset={maxHeightOffset}
        >
            {generateGrid(content)}
        </PostMediaCover>
    );
};
